module.exports = __webpack_public_path__ + "static/media/grid-item-b7.f1325490.png";